// Shared editorial card for /login, /signup, and the Providers-level
// Authenticator wrap (when an unauthenticated visitor lands on a
// protected APP route). Centred 420px card on bone background with
// rust-accent eyebrow rule, serif heading, muted lede.
//
// Single source of truth — both auth pages and the Providers wrap
// import this component. Adding a new auth surface only needs to set
// eyebrow / heading / lede.

export function AuthCard({
  eyebrow,
  heading,
  lede,
  children,
}: {
  eyebrow: string;
  heading: string;
  lede: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-1 items-center justify-center px-6 py-14 sm:px-10 sm:py-20">
      <div className="w-full max-w-[420px] rounded-[14px] border border-border bg-card p-8 shadow-[0_1px_2px_rgba(14,27,48,0.06),0_16px_40px_rgba(14,27,48,0.08)] sm:p-9">
        <span className="mb-5 inline-flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-accent before:h-px before:w-6 before:bg-accent before:content-['']">
          {eyebrow}
        </span>
        <h1 className="font-sans text-[32px] font-normal leading-[1.05] tracking-[-0.012em] text-foreground">
          {heading}
        </h1>
        <p className="mt-3 mb-7 text-[15px] leading-relaxed text-muted-foreground">
          {lede}
        </p>
        {children}
      </div>
    </div>
  );
}
